<template>
  <div
    class="select-skill-progress"
    @click="progressBarData.onClick"
  >
    <div
      class="progress-div"
      :style="progressBarData.style"
    >
      <div class="progress-div-text">
        {{ progressBarData.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, defineComponent } from "vue";
export default defineComponent({
 name: "GenericProgressBar",
 components: {},
 props: {
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
  progress: {
    type: Number,
    default: 0,
  },
 },
 setup(props) {
  const store = useStore();
  const getProgressBarText = () => {
    const activeStyle = store.state.ui.progressBarStyle.activeStyle;
    const currentProgress = Math.floor((props.progress / props.max) * 100);
    switch (activeStyle) {
      case 'default':
          return `${props.progress} / ${props.max} ( ${currentProgress}% )`;
      case 'currentAndMax':
          return `${props.progress} / ${props.max}`;
      case 'percent':
          return `${currentProgress}%`;
      case 'none':
          return '';
    }
  };
  const changeProgressBarStyle = () => {
    store.dispatch('handleIncomingCommand', {
        command: 'changeProgressBarStyle',
        data: null
    });
  };
  const progressBarData = computed(() => {
    const currentProgress = Math.floor((props.progress / props.max) * 100);
    return {
      onClick: changeProgressBarStyle,
      text: getProgressBarText(),
      style: `width: ${currentProgress}%;` 
    }
  })
  return {
    state: store.state,
    changeProgressBarStyle,
    getProgressBarText,
    progressBarData
  }
 },
})
</script>

<style scoped>
.select-skill-progress {
  position: relative;
  display: block;
  margin: auto;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 95%;
  height: 16px;
  border: var(--border-light);
  border-radius: 3px;
  border: 1px solid var(--text-tagged);
  background-color: rgba(81, 134, 81, 0.158);
}
.progress-div {
  /* max-width: 135px; */
  background-color: rgba(80, 168, 80, 0.747);
  background-color: rgba(133, 252, 90, 0.4);
  height: 16px;
  /* border: 1px solid rgba(233, 233, 233, 0.747); */
  /* border: 1px solid rgba(80, 168, 80, 0.747); */
  border-radius: 2px 2px 2px 2px;
  /* border: 1px solid var(--text-tagged); */
  border-right: 1px solid var(--text-tagged);
  border-radius: 3px;
}
.progress-div-text {
  position: absolute;
  top: 1px;
  left: 0px;
  width: 100%;
  right: auto;
  font-family: var(--font-family-gothic);
  font-size: 11px;
  color: white;
  letter-spacing: 1px;
}
.progress-div:hover {
  cursor: pointer;
}
</style>